import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M12.74 30.041h9.789c1.63 0 2.684-.99 2.759-2.631l.724-15.35h1.171a.93.93 0 0 0 .948-.937c0-.521-.415-.926-.948-.926h-4.74V8.599c0-1.63-1.033-2.599-2.8-2.599h-4.049c-1.757 0-2.801.97-2.801 2.599v1.598h-4.73a.932.932 0 1 0 0 1.864h1.183l.724 15.36c.075 1.64 1.119 2.62 2.77 2.62m2.013-21.346c0-.554.383-.905.98-.905h3.77c.597 0 .98.351.98.905v1.502h-5.73zm-1.81 19.46c-.587 0-1.013-.425-1.045-1.054l-.724-15.04H24.04L23.35 27.1c-.021.629-.448 1.055-1.055 1.055zm1.544-1.714c.447 0 .735-.288.724-.703l-.32-11.163c-.01-.426-.309-.703-.735-.703-.447 0-.735.287-.724.703l.32 11.163c.01.426.309.703.735.703m3.142 0c.447 0 .745-.288.745-.703V14.575c0-.416-.298-.703-.745-.703-.448 0-.746.287-.746.703v11.163c0 .415.299.703.746.703m3.142 0c.426 0 .714-.277.724-.703l.33-11.163c.011-.416-.287-.703-.724-.703-.426 0-.724.277-.735.703l-.33 11.163c-.01.415.288.703.735.703"
	})
});
export default SvgIcoDelete;
